import React, { useContext } from 'react';

import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import ChevronTopIcon from '../../../../assets/icons/ChevronTopIcon';
import { DiscoverContext } from '../../../../context/DiscoverContext';
import { colorsPalette } from '../../../../theme';
import useStyles from './styles';

interface CategoryNavigationProps {
  link: string;
  title: string;
}

const CategoryNavigation: React.FC<CategoryNavigationProps> = ({ link, title }) => {
  const classes = useStyles();
  const { setOpenFiltersPanel } = useContext(DiscoverContext);

  return (
    <Link
      to={link}
      className={classes.link}
      onClick={() => {
        setOpenFiltersPanel(false);
      }}
    >
      <ChevronTopIcon color={colorsPalette.white} className={classes.icon} />
      <Typography className={classes.text}>{title}</Typography>
    </Link>
  );
};

export default CategoryNavigation;
